import SmoothScroll from "smooth-scroll";
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";

const effects = () => {
  // Lazyload
  new LazyLoad({
    elements_selector: ".lazy",
    unobserve_entered: true,
  });

  // Smooth scroll
  new SmoothScroll("a[data-scroll][href*=\"#\"]", {
    speed: 400,
    offset() {
      const windowWidth = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;
      let offset = 64; // @UPDATE: navigation height
      if (windowWidth > 768) {
        offset = 0;
      }
      return offset;
    },
  });

  // In-view
  if (document.querySelector("[data-in-view]")) {
    inView.offset(0);

    inView("[data-in-view]")
      .on("enter", (el) => {
        el.classList.remove("data-clipping");
        el.classList.add("data-clipping");
      })
      .on("exit", (el) => {
        el.classList.remove("data-clipping");
      });
  }
};

export default effects;
